import { BarChart3, ListChecks, Search, UploadCloud, type LucideIcon } from 'lucide-react';

export const DASHBOARD = {
  /** Listed in the Recent Documents card; the body scrolls past what fits. */
  RECENT_DOCUMENT_COUNT: 20,
  RECENT_UPLOAD_WINDOW_DAYS: 7,
  FETCH_PAGE_SIZE: 100,
} as const;

export interface QuickAction {
  path: string;
  labelKey: string;
  descriptionKey: string;
  icon: LucideIcon;
  /** Hidden once the per-tenant design verification flag resolves to false (#1214). */
  requiresDesignVerification?: boolean;
}

export const DASHBOARD_QUICK_ACTIONS: QuickAction[] = [
  {
    path: '/documents/upload',
    labelKey: 'navigation.uploadDocument',
    descriptionKey: 'dashboard.quickActions.upload',
    icon: UploadCloud,
  },
  {
    path: '/search',
    labelKey: 'navigation.search',
    descriptionKey: 'dashboard.quickActions.search',
    icon: Search,
  },
  {
    path: '/drbfm',
    labelKey: 'navigation.drbfm',
    descriptionKey: 'dashboard.quickActions.drbfm',
    icon: BarChart3,
  },
  {
    path: '/verification',
    labelKey: 'navigation.verification',
    descriptionKey: 'dashboard.quickActions.verification',
    icon: ListChecks,
    requiresDesignVerification: true,
  },
];
